import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#programa", label: "Programa", testid: "nav-link-programa" },
  { href: "#niveles", label: "Niveles", testid: "nav-link-niveles" },
  { href: "#metodologia", label: "Metodología", testid: "nav-link-metodologia" },
  { href: "#modalidades", label: "Modalidad", testid: "nav-link-modalidades" },
  { href: "#faq", label: "Preguntas", testid: "nav-link-faq" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#inicio" className="flex items-center" data-testid="brand-logo">
          <img
            src="/logo-header.webp"
            alt="PIO Language Institute"
            className="h-11 sm:h-12 w-auto"
            data-testid="brand-logo-image"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contacto"
            data-testid="header-cta-button"
            className="hidden sm:inline-flex items-center rounded-full bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-700 transition-colors"
          >
            Solicitar información
          </a>
          <button
            type="button"
            aria-label="Abrir menú"
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden w-10 h-10 rounded-lg border border-slate-200 flex items-center justify-center text-slate-700"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-slate-200 bg-white px-4 py-4 flex flex-col gap-1" data-testid="mobile-nav">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-${l.testid}`}
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contacto"
            data-testid="mobile-header-cta-button"
            onClick={() => setOpen(false)}
            className="mt-2 rounded-full bg-blue-600 px-5 py-2.5 text-center text-sm font-semibold text-white"
          >
            Solicitar información
          </a>
        </nav>
      )}
    </header>
  );
}
